import { ActionMap } from "../types/action-map.type";
import { ResultsType } from "../types/results.type";
import { AutocompleteActions } from "./autocomplete.reducer";
import { HighlightActions } from "./highlight.reducer";
import { LanguageActions } from "./language.reducer";
import { SearchActions } from "./search.reducer";
import { StatusActions } from "./status.reducer";
import { SuggestionsActions } from "./suggestions.reducer";

export type ResultsActions = ActionMap<ResultsPayload>[keyof ActionMap<ResultsPayload>];
type ResultsPayload = {
  setResults: {
    results: ResultsType;
  }
}

export const resultsReducer = (results: ResultsType | undefined, action: LanguageActions | HighlightActions | ResultsActions | StatusActions | SearchActions | AutocompleteActions | SuggestionsActions) => {
  switch (action.type) {
    case 'setResults':
      return action.payload.results;
    default:
      return results;
  }
}
